// @ts-check
import styled from 'styled-components';
import Text from 'components/base/Text';

export const StyledDynamicIssueTypes = styled.div`
  border-top: 2px solid #ccc;
  border-bottom: 2px solid #ccc;
`;

export const StyledDynamicIssueTypeOption = styled.li`
  & ${Text} {
    text-transform: capitalize;
  }
`;
